var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpgradeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.58594 18.5859H11.5859M5.58594 15.5859H11.5859M5.58579 9.58579H1.99979C1.80204 9.58574 1.60874 9.52707 1.44433 9.41719C1.27992 9.3073 1.15178 9.15114 1.07611 8.96844C1.00044 8.78574 0.980636 8.58471 1.0192 8.39076C1.05777 8.1968 1.15298 8.01864 1.29279 7.87879L7.87879 1.29279C8.06631 1.10532 8.32062 1 8.58579 1C8.85095 1 9.10526 1.10532 9.29279 1.29279L15.8788 7.87879C16.0186 8.01864 16.1138 8.1968 16.1524 8.39076C16.1909 8.58471 16.1711 8.78574 16.0955 8.96844C16.0198 9.15114 15.8917 9.3073 15.7272 9.41719C15.5628 9.52707 15.3695 9.58574 15.1718 9.58579H11.5858V12.5858H5.58579V9.58579Z",
    stroke: "#A37028",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeIcon);
export default __webpack_public_path__ + "static/media/upgradeIcon.99ffd1b8393d528290462d2f3389f5fe.svg";
export { ForwardRef as ReactComponent };